import { useEffect, useState, lazy, Suspense } from 'react'

import { CuiModal } from 'front-lib'

import { ChangePlanForm } from './components/ChangePlanForm'
import { useChangePlanModal } from 'src/hooks/useChangePlanModal'

import './ChangePlanModal.scss'

// Lazy load ExpressPlanSelection to avoid circular dependency
const ExpressPlanSelection = lazy(() =>
  import('src/componentsV2/ExpressPlanSelection/ExpressPlanSelection')
)

export const ChangePlanModal = () => {
  const [title, setTitle] = useState('')
  const { isOpen, type, close } = useChangePlanModal()

  const isExpress = type === 'express'

  useEffect(() => {
    if (type === 'upgrade') {
      setTitle('Upgrade your plan')
    } else if (isExpress) {
      setTitle('Update the amount of meals')
    } else {
      setTitle('Change your plan')
    }
  }, [type, isExpress])

  return (
    <CuiModal
      className="change-plan-modal"
      isOpen={isOpen}
      onRequestClose={close}
      data-testid="change-plan-modal">
      <div
        className="change-plan-modal--title"
        data-testid="change-plan-modal-title">
        {title}
      </div>
      <div
        className="change-plan-modal--form"
        data-testid="change-plan-modal-form">
        {isExpress ? (
          <Suspense fallback={<div>Loading...</div>}>
            <ExpressPlanSelection display="grid" />
          </Suspense>
        ) : (
          <ChangePlanForm />
        )}
      </div>
    </CuiModal>
  )
}
